import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exemplary',
  templateUrl: './exemplary.component.html',
  styleUrls: ['./exemplary.component.scss']
})
export class ExemplaryComponent implements OnInit {
  pdfSrc='/assets/pdf/Exemplary_performance.pdf';
  isLoading=true;
  imgUrl:string[]=[
    '/assets/img/achievement/performance/23.jpg',
    '/assets/img/achievement/performance/22.jpg',
    '/assets/img/achievement/performance/21.jpeg',
    '/assets/img/achievement/performance/20.jpeg',
    '/assets/img/achievement/performance/19.jpeg',
    '/assets/img/achievement/performance/18.png',
    '/assets/img/achievement/performance/16.png',
    '/assets/img/achievement/performance/17.png',
    '/assets/img/achievement/performance/1.png',
    '/assets/img/achievement/performance/2.png',
    '/assets/img/achievement/performance/3.png',
    '/assets/img/achievement/performance/4.png',
    '/assets/img/achievement/performance/5.png',
    '/assets/img/achievement/performance/6.png',
    '/assets/img/achievement/performance/7.png',
    '/assets/img/achievement/performance/8.png',
    '/assets/img/achievement/performance/9.png',
    '/assets/img/achievement/performance/10.png',
    '/assets/img/achievement/performance/11.png',
    '/assets/img/achievement/performance/12.png',
    '/assets/img/achievement/performance/13.png',
    '/assets/img/achievement/performance/14.png',
    '/assets/img/achievement/performance/15.png',
  ]
  constructor() { }

  ngOnInit(): void {
  }
  hideLoader(){
    this.isLoading=false;
  }
}
